import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-read-line text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-bold font-heading text-background-50">韩漫网</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              免费韩漫大全，好看的韩国漫画在线观看平台。为您提供最新最全的韩漫资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">首页</Link>
              <Link to="/category/recommend" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">分类浏览</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">关于我们</Link>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">热门分类</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">恋爱漫画</Link>
              <Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">奇幻漫画</Link>
              <Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">动作漫画</Link>
              <Link to="/category/comedy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">搞笑漫画</Link>
              <Link to="/category/suspense" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200">悬疑漫画</Link>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-400">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                contact@hanman.com
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-customer-service-line"></i>
                在线客服：工作日 9:00-18:00
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫网 - 免费韩漫大全 | 好看的韩国漫画 | 韩漫在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">使用条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}